module.exports = __webpack_public_path__ + "img/7-1.8f4216c4.png";